import React from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EngineeringIcon from "@mui/icons-material/Engineering";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import DomainIcon from "@mui/icons-material/Domain";
import { motion } from "framer-motion";

const services = [
  {
    title: "Construction Management",
    icon: <HomeWorkIcon sx={{ fontSize: 50, color: "red" }} />,
    desc: "End-to-end coordination for material supply, scheduling, and site execution.",
  },
  {
    title: "Facade Engineering",
    icon: <EngineeringIcon sx={{ fontSize: 50, color: "red" }} />,
    desc: "Quality materials and logistics support for durable building exteriors.",
  },
  {
    title: "Apartment Solutions",
    icon: <ApartmentIcon sx={{ fontSize: 50, color: "red" }} />,
    desc: "Bulk supply of sand, aggregates, and bricks for residential projects.",
  },
  {
    title: "Urban Infrastructure",
    icon: <DomainIcon sx={{ fontSize: 50, color: "red" }} />,
    desc: "Material and logistics support for roads, highways, and urban development.",
  },
];

const Services_Box = () => {
  return (
    <Box
      sx={{
        py: 10,
        backgroundImage:
          "url('https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2023/03/serv_13.jpg')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        {/* Section Heading */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <Typography
            variant="h6"
            className="paraAfter-line"
            sx={{ color: "white", letterSpacing: 2, mb: 1 }}
          >
            OUR SERVICES
          </Typography>

          <Typography
            variant="h1"
            className="headPara"
            sx={{
              fontWeight: 700,
              color: "white",
              mb: 6,
            }}
          >
            Our Core Services
          </Typography>
        </motion.div>

        {/* Service Cards */}
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  duration: 0.6,
                  ease: "easeOut",
                  delay: index * 0.2, // 🔥 stagger left → right
                }}
              >
                <Card
                  sx={{
                    backgroundColor: "#2E0B00",
                    color: "white",
                    borderRadius: 2,
                    py: 4,
                    textAlign: "center",
                    transition: "0.3s",
                    border: "1px solid transparent",
                    "&:hover": {
                      borderColor: "red",
                      transform: "translateY(-8px)",
                    },
                  }}
                  elevation={0}
                >
                  <CardContent>
                    <Box mb={2} sx={{ color: "#ccc" }}>
                      {service.icon}
                    </Box>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {service.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.8, maxWidth: 260, mx: "auto" }}
                    >
                      {service.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services_Box;
